<template>
  <el-dialog
    title="模板预览"
    :visible="isShow"
    custom-class="temp-style"
    width="1000px"
    :before-close="handleClose"
  >
    <el-main
      v-if="isLoading"
      v-loading="isLoading"
      element-loading-text="模版正在渲染中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    />
    <template v-else>
      <el-row>
        <el-form
          ref="formData"
          :inline="false"
          :model="formData"
        >
          <el-col
            v-for="(item, index) in formData.headerFieldList"
            :key="index"
            :span="item.colSpan || 12"
          >
            <el-form-item
              :label="item.fieldDisplayName + ':'"
              :prop="item.fieldKey"
              label-width="110px"
            >
              <el-input
                v-if="item.attributeType === '输入框'"
                placeholder="请输入"
              />
              <p v-else />
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>

      <div class="flex flex-align product-style">
        <h4>产品信息</h4>
      </div>
      <el-table
        ref="tableDataRef"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column label="序号" align="left" fixed="left" type="index" />
        <el-table-column
          v-for="(item, index) in formData.productFieldList"
          :key="index"
          :prop="item.fieldKey"
          :label="item.fieldDisplayName"
          align="left"
        >
          <template slot-scope="scope">
            <el-input
              v-if="item.attributeType === '输入框'"
              v-model="scope.row[item.key]"
              placeholder="请输入"
            />
            <span v-else>
              {{ scope.row[item.key] || '' }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      isShow: false,
      isLoading: false,
      tableData: [],
      formData: {}
    };
  },

  methods: {
    openDialog (params) {
      this.formData = params.formData;
      this.isShow = true;
    },

    handleClose () {
      this.isShow = false;
    }
  }
};
</script>

<style lang="scss">
.temp-style {
  .el-dialog__body {
    min-height: 300px !important;
  }
  .el-main {
    min-height: 300px !important;
  }
}
</style>

<style lang="scss" scoped>
.temp-style {
  .flex {
    display: flex;
  }
  .flex-align {
    align-items: center;
  }
  .flex-1 {
    flex: 1;
  }
  .el-col {
    height: 40px;
  }
  h4 {
    margin: 10px 0;
  }
  .product-style {
    margin: 12px 0;
    .btn-style {
      margin-left: 20px;
    }
  }
}
</style>
